import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { ChevronDown } from 'react-feather'
import styles from './dashboard-form/checkbox.module.css'
import dayjs from 'dayjs'
import minMax from 'dayjs/plugin/minMax'
import { useInternationalization } from '../features/i18n'
dayjs.extend(minMax)

const thisYear = dayjs().year()
const FORMAT = 'YYYYMMDD'
const label = {
  from: {
    en: 'From',
    id: 'Dari'
  },
  to: {
    en: 'To',
    id: 'Untuk'
  }
}

const Option = ({onSelect = () => {}, checked, label, value}) => {
  return (
    <div
      className={`flex cursor-pointer ${styles.checkbox}`}
      onClick={onSelect}
    >
      <div>
        <input
          type="checkbox"
          className="hidden"
          onChange={e => null}
          value={value}
          checked={checked}
        />
        <div className={`mr-2 border flex justify-center items-center ${styles.outer}`}>
          <div className={styles.inner}></div>
        </div>
      </div>
      <label className="text-sm text-gray-444 pointer-events-none">
        {label}
      </label>
    </div>
  )
}

const DateFilter = ({className, placeholder, onSubmit = () => {}, /* onChange, type */}) => {
  const [isCustom, setIsCustom] = React.useState(false)
  const [customDate, setCustomDate] = React.useState({
    from: null,
    to: null
  })
  const [selected, setSelected] = React.useState([])
  const options = React.useMemo(() => {
    return [
      {
        label: 'Past 7 Days',
        value: `${dayjs().format(FORMAT)}_${dayjs().subtract(7,'days').format(FORMAT)}`
      },
      {
        label: 'Past 30 Days',
        value: `${dayjs().format(FORMAT)}_${dayjs().subtract(30,'days').format(FORMAT)}`
      },
      {
        label: 'Past 3 Months',
        value: `${dayjs().format(FORMAT)}_${dayjs().subtract(3,'months').format(FORMAT)}`
      },
      {
        label: 'Past 9 Months',
        value: `${dayjs().format(FORMAT)}_${dayjs().subtract(9,'months').format(FORMAT)}`
      },
      {
        label: String(thisYear),
        value: `${dayjs(String(thisYear)+'-1').format(FORMAT)}_${dayjs(String((thisYear+1)+'-1')).format(FORMAT)}`
      },
      {
        label: String(thisYear-1),
        value: `${dayjs(String((thisYear-1))+'-1').format(FORMAT)}_${dayjs(String((thisYear)+'-1')).format(FORMAT)}`
      },
      {
        label: String(thisYear-2),
        value: `${dayjs(String((thisYear-2))+'-1').format(FORMAT)}_${dayjs(String((thisYear-1)+'-1')).format(FORMAT)}`
      },
    ]
  }, [])
  const { language } = useInternationalization()

  const handleCustom = () => {
    updateSelected('custom')
    setIsCustom(!isCustom)
  }

  const updateSelected = (id) => {
    if(selected.includes(id)){
      setSelected(selected.filter(s => s !== id))
    } else {
      setSelected([...selected, id])
    }
  }

  const handleDateInput = (e) => {
    if(e && e.target && e.target.value){
      setCustomDate({
        ...customDate,
        [e.target.name]: dayjs(e.target.value).format(FORMAT)
      })
    }
  }

  const handleSubmit = () => {
    let dates = []
    let latestSelected = [...selected]

    if(selected.includes('custom')){
      const merged = `${customDate.from}_${customDate.to}`
      // latestSelected = [...selected.filter(s => s !== 'custom')]
      latestSelected.push(merged)
    }

    // Side effect
    setSelected(latestSelected)

    if(latestSelected.length > 0){
      for (let index = 0; index < latestSelected.length; index++) {
        const element = latestSelected[index];
        if(element.includes('_')){
          const splited = element.split('_')
          const newDates = [...dates, ...splited]
          dates = newDates
        }
      }

      let datesFormatted = dates.map(d => dayjs(d)),
        maxDate = dayjs.max(datesFormatted),
        minDate = dayjs.min(datesFormatted)

      console.log({maxDate, minDate})
      onSubmit({
        maxDate: maxDate.format('YYYYMMDD'),
        minDate: minDate.format('YYYYMMDD'),
      })
    }
  }

  return (
    <React.Fragment>
      <Dropdown className="w-full">
        <DropdownTrigger>
          <div
            className={`rounded border p-2 w-full bg-white text-sm cursor-pointer flex justify-between items center ${className}`}
            style={{borderColor: 'hsl(0,0%,80%)', color: '#808080'}}
          >
            <div>{placeholder ? placeholder : 'Date'}</div>
            <div><ChevronDown style={{width: '20px', height: '20px', color: 'hsl(0,0%,80%)'}}/></div>
          </div>
        </DropdownTrigger>
        <DropdownContent className="no-tip">
          <div>
            <div className="text-sm p-4 font-primary normal-case font-normal border-b text-gray-444" style={{borderColor: '#eee'}}>
              {
                options.map(option => (
                  <div className="mb-2" key={option.value}>
                    <Option
                      id={option.label}
                      onSelect={() => updateSelected(option.value)}
                      checked={selected.includes(option.value)}
                      label={option.label}
                      value={option.value}
                    />
                  </div>
                ))
              }

              <div className="mb-2">
                <Option
                  id={'Custom'}
                  onSelect={() => handleCustom()}
                  checked={selected.includes('custom')}
                  label={'Custom'}
                  value={'custom'}
                />
              </div>
            </div>

            <div className="text-gray-444 text-sm p-4 font-primary normal-case font-normal">
              {
                isCustom && <>
                  <div className="mb-4">
                    <label htmlFor="from" className="mb-1">{label.from[language.name]}</label>
                    <input
                      type="date"
                      className={`rounded border py-2 px-4 w-full bg-white text-sm cursor-pointer ${className}`}
                      id="from"
                      name="from"
                      onChange={handleDateInput}
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="to" className="mb-1">{label.to[language.name]}</label>
                    <input
                      type="date"
                      className={`rounded border py-2 px-4 w-full bg-white text-sm cursor-pointer ${className}`}
                      id="to"
                      name="to"
                      onChange={handleDateInput}
                    />
                  </div>
                </>
              }
              <button
                className="w-full border rounded text-primary text-center p-3"
                style={{borderColor: '#52BAE2'}}
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { DateFilter }
